import SockJS from 'sockjs-client';
import Stomp from 'webstomp-client'
import { reportDialog } from '../_store/reportDialog.module';
import { dialogMessage } from '../_store/dialogMessage.module';
import { authentication } from '../_store/authentication.module';
import { config } from '../_helpers/config';
let stompClient = null;
let mainConfig = config.apiUrl
let sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
export function connectWebSocket() {
  const socket = new SockJS(`${mainConfig}ws?access_token=${localStorage.getItem("access_token")}`)
  stompClient = Stomp.over(socket);
  stompClient.subscribe = awaitDecorator(stompClient.subscribe)
  stompClient.connect({}, () => {
    stompClient.subscribe('/user/topic/newMessage', (message) => {
      if (message.body) {
        let body = JSON.parse(message.body)
        reportDialog.mutations.addNewComment(reportDialog.state, body)
        if(authentication.getters.checkRole(2)) {
          dialogMessage.mutations.setHasUnreadMessage(dialogMessage.state, true)
        }
      }
    });
  }, (error) => {
    console.error('WebSocket error:', error);
  });

  socket.onclose = () => {
    setTimeout(() => {
      connectWebSocket()
    }, 30000)
  }
}
let awaitDecorator = (f) => {
  return async function () {
    if (stompClient.connected) return f.apply(this, arguments)
    await sleep(300)
    return f.apply(this, arguments)
  }
}
export function disconnectWebSocket() {
  if (stompClient !== null) {
    stompClient.disconnect();
  }
}